import React, { FC } from "react";
import { Field } from "react-final-form";
import { Grid } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";
import Autocomplete from "../../../../../components/Autocomplete";
import { currencies } from "../../../../../utils/const/currencies";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { ICourseComponentProps, ICurrencyFrontEndModel } from "../../../types";
import { COMMISSION_TYPES, getDurationUnits } from "../../../../../constants";
import ShowCurrency from "./ShowCurrency";

const durationUnitWithoutDays = getDurationUnits("Course").slice(1);

const currencyList: ICurrencyFrontEndModel[] = currencies.map((item) => ({
  id: item.id,
  name: item.code,
}));

interface IPriceProps extends ICourseComponentProps {
  durationAmountRequired: boolean;
  currency: string;
}

const Price: FC<IPriceProps> = ({
  fieldsGroupName,
  durationAmountRequired = true,
  currency,
}) => {
  return (
    <div>
      <FieldsGroupLabel label="Price" className="fields-group-label-first" />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            type="text"
            label="Price"
            placeholder="Only numbers"
            name={`${fieldsGroupName}.price`}
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            label="Currency"
            options={currencyList}
            placeholder="Please Select"
            infoIcon={"Choose currency you require"}
            name={`${fieldsGroupName}.currency`}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            label="Duration Period"
            options={durationUnitWithoutDays}
            placeholder="Please Select"
            name={`${fieldsGroupName}.priceDurationUnit`}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required={durationAmountRequired}
            fullWidth
            type="text"
            disabled={!durationAmountRequired}
            label="Duration"
            placeholder={durationAmountRequired ? "Only numbers" : ""}
            infoIcon={"The price you indicate for the following period"}
            name={`${fieldsGroupName}.priceDurationAmount`}
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Field
            required
            fullWidth
            type="text"
            label="Commission"
            placeholder="Only numbers"
            infoIcon={"Indicate percentage or fee for 1st year"}
            name={`${fieldsGroupName}.commissionAmount`}
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Field
            required
            fullWidth
            label="Type"
            options={COMMISSION_TYPES}
            placeholder="Please Select"
            name={`${fieldsGroupName}.commissionType`}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ShowCurrency currency={currency} />
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(Price);
